export enum DateFormatEnum {
  Seconds = "ss",
  Minutes = "mm",
  Hours = "HH",
  HoursMinutes = "HH:mm",
  Time = "HH:mm:ss",
  Days = "dd",
  Months = "MM",
  MonthsYears = "MM.yyyy",
  Years = "yyyy",
  FullTime = "HH:mm:ss",
  DayMonth = "dd MMMM",
  DayMonthWithDot = "dd.MM",
  DayMonthYear = "dd.MM.yyyy",
  DayMonthYearAndTime = "dd.MM.yyyy HH:mm",
  DayMonthYearAndFullTime = "dd.MM.yyyy HH:mm:ss",
  YearMonth = "yyyy-MM",
  YearMonthDay = "yyyy-MM-dd",
  YearMonthDayHour = "yyyy-MM-dd HH",
  YearMonthDayAndTime = "yyyy-MM-dd HH:mm",
  YearMonthDayAndFullTime = "yyyy-MM-dd HH:mm:ss",
  FullDateAndTimeOffset = "yyyy-MM-dd HH:mm:ss XXX",
  FullDateAndTimeZone = "yyyy-MM-dd HH:mm:ssXXX",
  TimeAndDayMonthYear = "HH:mm dd.MM.yyyy",
  TimeOffset = "XXX",
  YearMonthDayAndFullTimePortion = "yyyy-MM-dd'T'HH:mm:ss",
  YearMonthDayAndTimePortion = "yyyy-MM-dd'T'HH:mm",
  DefaultDateTimeFormat = "yyyy-MM-dd'T'HH:mm:ss.SSS",
}
